<template>
  <div id="app">
<!--    <img alt="Vue logo" src="./assets/logo.png">-->
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--    <Index></Index>-->
    <router-view/>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import Index from "@/components/Index.vue";

export default {
  name: 'app',
  components: {
    // Index
  },
  data(){
	  return{
		  user:JSON.parse(sessionStorage.getItem('CurUser')),
	  }
  },
  watch:{
	  '$store.state.menu':{
		  handler(val,old){
			  
			  console.log("11111---" + JSON.stringify(old));
			  console.log("11111---1" + JSON.stringify(this.user))
			 
			  
			  if(!old && this.user && this.user.account){
				  this.$store.commit("setRounter",val);
			  }
			  
			  if(!old && !this.user){
				  sessionStorage.clear();
				  this.$router.push('/');
			  }
		  },
		  immediate:true
	  }
  }
}
</script>

<style>
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
</style>
